import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function PainSection() {
  const {
    lang
  } = useLanguage();
  const situations = [{
    tag: '01',
    text: 'Tienes la idea y el talento, pero no sabes por dónde empezar ni cómo presentarte profesionalmente.',
    textEn: "You have the idea and the talent, but you don't know where to start or how to present yourself professionally."
  }, {
    tag: '02',
    text: 'Ya tienes algo creado, pero se ve desorganizado y no transmite el verdadero valor de quién eres.',
    textEn: "You already have something created, but it looks disorganized and doesn't convey the true value of who you are."
  }, {
    tag: '03',
    text: 'Tienes presencia pero sin un sistema claro, sin un mensaje definido y sin saber cómo monetizar.',
    textEn: 'You have a presence but without a clear system, without a defined message, and without knowing how to monetize.'
  }];
  return <section id="problema" className="py-32 lg:py-40 bg-inkova-cream relative" data-id="element-273">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-274">
        <div className="text-center mb-20" data-id="element-275">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 mb-8" data-id="element-276">
            <span className="block w-[1px] h-[40px] bg-inkova-primary/30" data-id="element-277" />
            <span className="inline-block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary" data-id="element-278">
              {lang === 'es' ? 'EL PUNTO DE PARTIDA' : 'THE STARTING POINT'}
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.1
        }} className="text-[32px] sm:text-[4vw] lg:text-[56px] font-serif text-inkova-dark leading-[1.1] tracking-[-0.5px] max-w-[800px] mx-auto" data-id="element-279">
            {lang === 'es' ? <>
                ¿Te suena familiar{' '}
                <em className="italic text-inkova-lavender" data-id="element-280">alguna</em> de
                estas?
              </> : <>
                Do any of these sound{' '}
                <em className="italic text-inkova-lavender" data-id="element-281">familiar?</em>
              </>}
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-24 max-w-[1000px] mx-auto" data-id="element-282">
          {situations.map((sit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: index * 0.15
        }} className="group relative bg-white rounded-[20px] px-9 py-12 border border-inkova-border hover:-translate-y-2 hover:shadow-[0_24px_64px_rgba(107,63,160,0.10)] hover:border-inkova-primary/20 transition-all duration-500 flex flex-col items-start overflow-hidden min-h-[340px]" data-id="element-283">
              {/* Large ghost number watermark */}
              <span className="pointer-events-none select-none absolute -top-6 -right-2 font-serif font-semibold text-[140px] leading-none text-inkova-primary/[0.05] group-hover:text-inkova-primary/[0.08] transition-colors duration-500" data-id="element-284">
                {sit.tag}
              </span>

              {/* Thin-line numeral badge */}
              <div className="relative z-10 mb-10 w-[52px] h-[52px] flex items-center justify-center border border-inkova-primary/25 rounded-[10px]" data-id="element-285">
                <span className="font-serif text-[20px] text-inkova-primary italic" data-id="element-286">
                  {sit.tag}
                </span>
              </div>

              <p className="relative z-10 text-[16px] text-inkova-dark/80 leading-[1.8] font-light mt-auto" data-id="element-287">
                {lang === 'es' ? sit.text : sit.textEn}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} className="text-center max-w-[820px] mx-auto pt-12 pb-4" data-id="element-288">
          <p className="text-[28px] sm:text-[34px] lg:text-[42px] font-serif italic text-inkova-dark/70 leading-[1.35]" data-id="element-289">
            {lang === 'es' ? '"Si te identificaste con alguna — estás en el lugar correcto."' : '"If you identified with any of these — you are in the right place."'}
          </p>
        </motion.div>
      </div>
    </section>;
}